import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { IconClinicalTrials } from '@medifind/icons';
import { IconArrowSmall } from '@medifind/icons';
import { generateURL } from '@medifind/router';
import { useRouter } from '@medifind/router';
import { usePageHooks } from '@medifind/router';
import { SEO } from '@medifind/seo';
import { MFLazyLoad } from '@medifind/shared-basic-components';
import { Button } from '@medifind/shared-basic-components';
import ClinicalTrialStepper from '../../components/clinical-trials/ClinicalTrialStepper';
import styles from '../../components/clinical-trials/TrialSearchShared.module.scss';
import { Splash, SplashFAQs } from '../../components/Splash';

/**
 * TODO Contact Us nav to contact us page
 */

/* __ROUTE_PATH__=/clinical-trials */
const TrialSearch = () => {
  usePageHooks();
  const router = useRouter();

  const queryParams = router.query;
  const { permalink, bookmarkId, isStarted: queryIsStarted } = queryParams;
  const isBookmarked = !!permalink || !!bookmarkId;
  const [isStarted, setIsStarted] = useState(queryIsStarted || isBookmarked);

  useEffect(() => {
    setIsStarted(queryIsStarted);
  }, [queryIsStarted]);

  const handleGetStartedClick = () => {
    setIsStarted(true);

    router.history.push(
      generateURL('/clinical-trials', {
        step: 0,
        isStarted: true,
      }),
    );
  };

  return (
    <>
      {!isStarted && (
        <Splash
          swapActionDescription
          action={
            <Button
              label="Get Started"
              onClick={handleGetStartedClick}
              icon={<IconArrowSmall color="white" />}
              className={classNames(styles['get-started-button'])}
            />
          }
          icon={<IconClinicalTrials width={104} height={104} />}
          title={'Clinical Trials'}
          subtitle={'Find hope with cutting-edge treatments'}
          description={
            'If you’ve exhausted all treatment options, or are simply looking for a different approach, you may find new hope in clinical trials. We identify all active and ongoing clinical trials near you, so you can discover new opportunities to discuss with your physician.'
          }
          className={styles['page-trial-search']}
        />
      )}
      <SEO
        title="Clinical Trials | MediFind"
        description="Looking for active clinical trials for your specific condition? Find clinical trials and research studies with MediFind's innovative clinical trial search tool."
        images={[
          {
            url: 'https://cdn.medifind.com/assets/help-journey-trials-big.png',
            width: 416,
            height: 416,
          },
        ]}
      />
      {isStarted ? (
        <ClinicalTrialStepper />
      ) : (
        <MFLazyLoad height={750} noSuspense>
          <SplashFAQs
            blurbTitle={'Search for Clinical Trials'}
            blurbBody={
              'There are thousands of new clinical trials around the world every year, each offering the potential for life-changing discoveries. We help you stay on top of them. If you’re interested in exploring cutting-edge treatment options, we help you quickly and easily find the trials that are most relevant to you.'
            }
            slug={'trial-search'}
          />
        </MFLazyLoad>
      )}
    </>
  );
};

export default TrialSearch;
